import { Box, Fade, Stack, styled } from '@mui/material'
import { memo, useRef, useState } from 'react'
import { useCurrentNetwork, useSupportChains } from 'store/app/hooks'
import { ReactComponent as IconArrow } from './assets/arrow.svg'
import { useOnClickOutside } from 'usehooks-ts'
import { useSwitchNetwork } from 'hooks/web3/useSwitchNetwork'
import clsx from 'clsx'
import { IconSelected } from 'components/Icons'

const DepositNetworksWrap = styled(Box)`
  display: flex;
  height: 56px;
  background-color: rgba(22, 25, 30, 1);
  border-radius: 6px;
  position: relative;
  user-select: none;
  &.open {
    z-index: 20;
  }
`
const CurrentNetwork = styled('div')`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  cursor: pointer;

  .arrow {
    color: rgba(149, 164, 173, 1);
  }

  &.open {
    .arrow {
      transform: rotate(180deg);
      color: rgba(255, 255, 255, 1);
    }
  }
`
const NetworkIcon = styled('img')`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
`
const NetworkName = styled('div')`
  flex: 1;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
`
const NetworkPopup = styled(Stack)`
  position: absolute;
  top: 56px;
  left: 0;
  right: 0;
  gap: 8px;
  max-height: 320px;
  overflow-y: auto;
  padding: 16px 0;
  background-color: rgba(42, 49, 57, 1);
  border-top: 1px solid rgba(160, 238, 9, 1);
  border-radius: 0 0 6px 6px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.25);
`
const NetworkOption = styled('div')`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;
  height: 48px;
  padding: 0 16px;
  transition: background-color 0.2s ease-in-out;

  .flag {
    display: none;
  }

  &:hover {
    background-color: rgba(57, 65, 73, 1);
    cursor: pointer;
  }

  &.checked {
    background-color: rgba(160, 238, 9, 0.1);
    cursor: default;

    > div {
      color: rgba(160, 238, 9, 1);
    }

    .flag {
      display: block;
    }
  }
`

export const DepositNetworks = memo(() => {
  const [showPopup, setShowPopup] = useState(false)
  const wrap = useRef<any>(null)

  useOnClickOutside(wrap, () => setShowPopup(false))

  const currentNetwork = useCurrentNetwork()
  const supportChains = useSupportChains()

  const switchNetwork = useSwitchNetwork()

  const { name = '', iconUrl = '' } = currentNetwork ?? {}
  return (
    <DepositNetworksWrap ref={wrap} className={clsx({ open: showPopup })}>
      <CurrentNetwork
        className={clsx({ open: showPopup })}
        onClick={() => setShowPopup(!showPopup)}
      >
        <NetworkIcon src={iconUrl} />
        <NetworkName>{name}</NetworkName>
        <IconArrow className="arrow" />
      </CurrentNetwork>

      {showPopup ? (
        <NetworkPopup>
          {supportChains.map((v) => (
            <NetworkOption
              key={v.layerOneChainId}
              className={clsx({
                checked:
                  Number(currentNetwork?.layerOneChainId) ===
                  Number(v?.layerOneChainId),
              })}
              onClick={() => {
                switchNetwork(v?.layerOneChainId)
                setShowPopup(false)
              }}
            >
              <NetworkIcon src={v?.iconUrl} />
              <NetworkName>{v?.name}</NetworkName>
              <IconSelected className={'flag'} />
            </NetworkOption>
          ))}
        </NetworkPopup>
      ) : null}
    </DepositNetworksWrap>
  )
})
